import { useQueryClient } from '@tanstack/react-query'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import PeopleTable from '../../../components/tables/PeopleTable'
import TeamTable from '../../../components/tables/TeamTable'

import { Flex, VStack } from '@chakra-ui/react'
import AssetsTable from '../../../components/tables/AssetsTable'
import MutationsTable from '../../../components/tables/MutationsTable'
import WorkforceOrganizationTable from '../../../components/tables/WorkforceOrganizationTable'
import BenefitMutationsPage from './BenefitMutationsPage'

interface UserWorkforcePageProps {
  selectedTab: string
}

const UserWorkforcePage: React.FC<UserWorkforcePageProps> = ({ selectedTab }) => {
  const [isScrolled, setIsScrolled] = useState(false)
  const queryClient = useQueryClient()

  // to get the page number to return to after navigating back
  const location = useLocation()
  const state = location.state as { page?: number } | null
  const initialPeoplePage = state?.page ?? 1

  // Called by AddEmployeesModal after it has already created the employee (no second POST).
  const handleAddEmployee = (_employee: unknown) => {
    queryClient.invalidateQueries({ queryKey: ['people'] })
  }

  const renderTable = () => {
    if (selectedTab === 'people') {
      return <PeopleTable initialPage={initialPeoplePage} onAddEmployee={handleAddEmployee} />
    } else if (selectedTab === 'teams') {
      return <TeamTable setData={() => { }} />
    } else if (selectedTab === 'organization') {
      return <WorkforceOrganizationTable />
    } else if (selectedTab === 'assets') {
      return <AssetsTable />
    } else if (selectedTab === 'mutations') {
      return <MutationsTable />
    } else if (selectedTab === 'benefit-mutations') {
      return <BenefitMutationsPage />
    }
    return null
  }

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(event.currentTarget.scrollTop > 0)
  }

  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      height="100%"
      overflowY="auto"
      onScroll={handleScroll}
      borderRadius={isScrolled ? '10px' : '0'}
    >
      <VStack gap={{ base: '12px', md: '16px' }} width="100%">
        {renderTable()}
      </VStack>
    </Flex>
  )
}

export default UserWorkforcePage
